import axios from "axios";
import Cookies from "js-cookie";

const baseUrl = process.env.REACT_APP_API_URL;

export const droneEntrepreneur = async (data) => {
  const url = baseUrl + `/droneEntrepreneur`;

  try {
    const response = await axios.post(url, data, {
      headers: {
        token: Cookies.get("token"),
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
export const droneDistributor = async (data) => {
  const url = baseUrl + `/droneDistributor`;

  try {
    const response = await axios.post(url, data, {
      headers: {
        token: Cookies.get("token"),
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
export const rpto = async (data) => {
  const url = baseUrl + `/rpto`;

  try {
    const response = await axios.post(url, data, {
      headers: {
        token: Cookies.get("token"),
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
export const daas = async (data) => {
  const url = baseUrl + `/daas`;

  try {
    const response = await axios.post(url, data, {
      headers: {
        token: Cookies.get("token"),
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
